import * as S from './Footer.styled';
import ColorfulBtn from 'views/UserDashboard/UserDashboardV4/components/BookACallButton/colorfulBtn';

type Props = {
    activateActionButton: () => void;
};

const Footer = ({ activateActionButton }: Props) => {
    const footerActionButton = () => {
        activateActionButton();
    };

    return (
        <S.FooterContainer>
            <ColorfulBtn payVisaFee={footerActionButton} />
        </S.FooterContainer>
    );
};

export default Footer;
